@layer chart {
  .styledModal {
    [data-modal-text-container] {
      margin-top: 18px;
      margin-bottom: 0;
    }

    [data-modal-container] {
      width: 600px;
    }
  }

  .text {
    font-size: 1.063rem;
    line-height: 1.5rem;
    font-weight: 400;
    color: var(--text-default);
  }
}
